export const DestinosActionTypes = {
  API_RESPONSE_SUCCESS: '@@destinos/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@destinos/API_RESPONSE_ERROR',

  GET_DESTINO: '@@destinos/GET_DESTINO',
  LIST_DESTINOS: '@@destinos/LIST_DESTINOS',
  ADD_DESTINO: '@@destinos/ADD_DESTINO',
  UPDATE_DESTINO: '@@destinos/UPDATE_DESTINO',
  DELETE_DESTINO: '@@destinos/DELETE_DESTINO',
  SET_FILTER: '@@destinos/SET_FILTER',

  RESET: '@@destinos/RESET'
}
